<template>
  <div class="finishedCheckBillsSummary">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="checkBox">
          <checkbox v-model="item.isSelected" @input="handleCheckBox"></checkbox>
        </div>
        <div class="container" @click="gotoDetail(item)">
          <div class="list-item">
            {{ $t.finishedCheckBillsSummary.nuclearAccountNo }}：{{
              item.NuclearAccountNo
            }}
          </div>
          <div class="list-item">
            {{ $t.finishedCheckBillsSummary.creditDate }}：{{ item.CreateTime }}
          </div>
          <div class="list-item">
            {{ $t.finishedCheckBillsSummary.customerName }}：{{ item.CompanyNameSn }}
          </div>
          <div class="list-item">
            {{ $t.finishedCheckBillsSummary.nuclearType }}：{{ item.NuclearTypeStr }}
          </div>
          <div class="subTotal" v-if="item && item.ReceivedAmountList.length > 0">
            <div class="subTotal-label">
              {{ $t.finishedCheckBillsSummary.receivableAmount }}
            </div>
            <div
              class="subTotal-item"
              v-for="(item, index) in item.ReceivedAmountList"
              :key="index"
            >
              <div class="item1">{{ item.CurrencySn }}</div>
              <div class="item2">{{ item.TotalAmount }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">
          {{ $t.finishedCheckBillsSummary.nuclearType }}
        </div>
        <van-radio-group v-model="nuclearType" direction="horizontal">
          <van-radio :name="1">{{ $t.finishedCheckBillsSummary.nuType1 }}</van-radio>
          <van-radio :name="2">{{ $t.finishedCheckBillsSummary.nuType2 }}</van-radio>
          <van-radio :name="3">{{ $t.finishedCheckBillsSummary.nuType3 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.customerTitle }}</div>
        <van-radio-group v-model="customerType" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.enterprise }}</van-radio>
          <van-radio :name="2">{{ $t.meta.personal }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.statistics }}</div>
        <van-radio-group v-model="dataQueryCriteria" direction="horizontal">
          <van-radio :name="0">{{ $t.finishedCheckBillsSummary.all }}</van-radio>
          <van-radio :name="1">{{ $t.finishedCheckBillsSummary.dataOtion1 }}</van-radio>
          <van-radio :name="2">{{ $t.finishedCheckBillsSummary.dataOtion2 }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar" v-if="checkedList && checkedList.length > 0">
      <div class="tool-bar-wrapper">
        <div class="tool-bar-total">
          <div class="tool-bar-total-left">{{ $t.meta.selectTotal }}</div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in checkedList"
            :key="index"
          >
            <div class="item1">{{ item.name }}</div>
            <div class="item2">{{ item.value.toFixed(2) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

import Checkbox from "@components/checkbox/Checkbox.vue";
export default {
  name: "finishedCheckBillsSummary",
  components: {
    Checkbox,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.finishedCheckBillsSummary.wbNumber,
          value: 1,
        },
        {
          text: this.$t.finishedCheckBillsSummary.customerNumber,
          value: 2,
        },
        {
          text: this.$t.finishedCheckBillsSummary.nuclearAccountNo,
          value: 3,
        },
        {
          text: this.$t.finishedCheckBillsSummary.companyName,
          value: 4,
        },
        {
          text: this.$t.finishedCheckBillsSummary.warehouseWorkNumber,
          value: 5,
        },
        {
          text: this.$t.finishedCheckBillsSummary.workOrderNumber,
          value: 6,
        },
      ],
      dataQueryCriteria: 1,
      nuclearType: null,
      customerType: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //选中框
      checkedList: [],
    };
  },
  created() {
    this.defaultDate();
  },
  methods: {
    initCheckList() {
      if (this.tableData.length > 0) {
        var currency = this.tableData[0];
        this.checkedList = [
          {
            id: currency.ReceivedAmountList[0].SCId,
            name: currency.ReceivedAmountList[0].CurrencySn,
            value: 0,
          },
          {
            id: currency.ReceivedAmountList[1].SCId,
            name: currency.ReceivedAmountList[1].CurrencySn,
            value: 0,
          },
          {
            id: currency.ReceivedAmountList[2].SCId,
            name: currency.ReceivedAmountList[2].CurrencySn,
            value: 0,
          },
        ];
      } else {
        this.checkedList = [];
      }
    },
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.isSelected);
      if (items.length > 0) {
        var currency = this.tableData[0];
        var C1 = {
          id: currency.ReceivedAmountList[0].SCId,
          name: currency.ReceivedAmountList[0].CurrencySn,
          value: 0,
        };
        var C2 = {
          id: currency.ReceivedAmountList[1].SCId,
          name: currency.ReceivedAmountList[1].CurrencySn,
          value: 0,
        };
        var C3 = {
          id: currency.ReceivedAmountList[2].SCId,
          name: currency.ReceivedAmountList[2].CurrencySn,
          value: 0,
        };
        for (var item of items) {
          for (let index in item.ReceivedAmountList) {
            if (index == 0) {
              C1.value = C1.value + item.ReceivedAmountList[0].TotalAmount;
            }
            if (index == 1) {
              C2.value = C2.value + item.ReceivedAmountList[1].TotalAmount;
            }
            if (index == 2) {
              C3.value = C3.value + item.ReceivedAmountList[2].TotalAmount;
            }
          }
        }
        list.push(C1);
        list.push(C2);
        list.push(C3);
        this.checkedList = list;
      } else {
        this.initCheckList();
      }
    },
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10 ? "0" + date.getDate().toString() : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.beginTime = beg;
      this.endTime = end;
    },
    gotoDetail(item) {
      var data = item;
      localStorage.setItem("finishedCheckBillsSummaryDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "finishedCheckBillsSummaryDetail",
        name: "finishedCheckBillsSummaryDetail",
        query: [],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList();
    },
    isFilter() {
      if (this.nuclearType || this.customerType) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.nuclearType = null;
      this.customerType = null;
      this.dataQueryCriteria = 1;
      this.defaultDate();
      this.initList();
      this.getList();
    },
    filterSubmit() {
      this.initList();
      this.getList();
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
      this.initCheckList();
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    getList() {
      var param = {
        NuclearType: this.nuclearType,
        CustomerType: this.customerType,
        DataQueryCriteria: this.dataQueryCriteria,
        WB_Number: this.searchType == 1 ? this.searchText : "",
        CustomerNumber: this.searchType == 2 ? this.searchText : "",
        NuclearAccountNo: this.searchType == 3 ? this.searchText : "",
        CompanyName: this.searchType == 4 ? this.searchText : "",
        WarehouseWorkNumber: this.searchType == 5 ? this.searchText : "",
        WorkOrderNumber: this.searchType == 6 ? this.searchText : "",
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.financialManagement
        .getNuclearAccountRecordsList(param)
        .then((res) => {
          this.tableData = res.data;
          this.initCheckList();
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.finishedCheckBillsSummary {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 15px;
      }
      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
        .buttons {
          text-align: right;
          padding-bottom: 10px;
          .primary-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-primary;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .default-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-light-gray;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .search-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-green;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .danger-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-red;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar-total {
    font-size: 12px;
    color: #333333;
    background: #fff;
    .tool-bar-total-left {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .checkbox {
        display: inline-flex;
        span {
          margin-left: 10px;
        }
      }
    }
    .tool-bar-total-item {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .subTotal {
    margin-bottom: 10px;
    font-size: 12px;
    color: #333333;
    .subTotal-label {
      margin-bottom: 10px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .subTotal:last-child {
    margin-bottom: 0px !important;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
